import * as types from "../../mutation-types";

export default {
  [types.GET_PRODUCTS](state, data) {
    state.products = data;
  },
};
